import React from 'react';
import { Link } from 'react-router-dom';
import { useFeeConfig } from '../../../services/config.service';

const Request = () => {
  const { config: feeConfig, isLoading, isUsingDefaults } = useFeeConfig();

  return (
    <>
      <section className="sicknote-request pt-120 pb-30">
        {/* <div className="floating-btn-container">
          <Link
            className="primary_btn w-100 btn-icon btn-hide no-icon-btn center"
            to="/login"
            id="request-note"
          >
            Request SICK NOTE now{" "}
          </Link>
        </div> */}

        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
              <div className="section-title text-center pos-rel mb-40">
                <div className="section-icon">
                  <img className="section-back-icon" src="img/section/section-back-icon.png" alt="" />
                </div>
                <div className="section-text pos-rel">
                  <h5>Online Sick Note Service</h5>
                  <h2>Request a Sick Note Online – Fast, Secure, and Doctor-Issued</h2>
                </div>
                <div className="section-line pos-rel">
                  <img src="img/shape/section-title-line.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
              <div className="service-intro-content text-center">
                <p className="my-3 font-size-18">
                  Need a sick note for work or school absence? SouthVanMed offers a fast and secure online sick note service. Submit your request in minutes and receive a doctor-issued note—often
                  within 1 business day.
                </p>
                <p className="font-size-18">This service is trusted by patients across British Columbia. Your information is protected under BC's PIPA (Personal Information Protection Act).</p>
                <p className="mt-3 font-size-18 font-weight-500">
                  <strong>Please note:</strong> A minimum fee of ${isLoading ? '...' : feeConfig.SICK_NOTE.MSP_ELIGIBLE} applies. In some cases, the patient may need to be contacted by phone or seen
                  in person or virtually before the note can be completed.
                </p>
                {isUsingDefaults && (
                  <div className="alert alert-warning mt-2">
                    <small>Using cached pricing. Current rates may vary.</small>
                  </div>
                )}
                <div className="call-to-action mt-4">
                  <p className="mb-4 font-size-18 font-weight-500">
                    <span className="check-icon">✅</span> Request your sick note now – fast, secure, and fully compliant.
                    <br />
                    Doctor-reviewed and accepted by most employers and schools.
                  </p>
                  <Link to="/medicalInfo?formType=sick-note" className="primary_btn btn-icon btn-hide no-icon-btn center">
                    Get My Sick Note <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Request;
